import React from 'react';
import './Products.css'
import '../gsdecss/gsde.css'
import AllseisShow from './allseisShow/AllseisShow';
import AllseisItem, { IAllseis } from './allseisShow/AllseisItem';
import img_3c from './allseisShow/images/allseis-3C.jpg';
import img_4c from './allseisShow/images/allseis-4C.jpg';
import img_1c from './allseisShow/images/allseis-1C.jpg';

const allseisdata: IAllseis[] = [
    {
        title: "ALLSEIS-1C 一体化单站单道地震采集节点",
        src: img_1c,
        profile: (
            <>
                <p>&nbsp;&nbsp; 作为国产自主研发与制造的高端探测装备，其在本底噪声抑制水平、一致性、可靠性等方面，均处于国际同类产品领先地位，检波器性能与MEMS数字检波器相当。</p>
                <p>&nbsp;&nbsp; 内置高灵敏度5Hz或10Hz检波器，可选配压电或MEMS检波器，并可以通过KCK转接缆外接检波器串采集，适用于大范围二维或者三维高密度反射波地震勘探。</p>
            </>
        ),
        bases: [
            {
                name: "数字化方案",
                value: <><div>32位高精度</div><div>瞬时动态范围优于144dB</div></>,
            },
            {
                name: "固态存储容量",
                value: "12GB/32GB/64GB可选",
            },
            {
                name: "内置电池",
                value: <><div>内置锂电池</div><div>连续工作时长大于600小时</div></>,
            },
            {
                name: "外部供电",
                value: "可外接电池或12V供电线缆",
            },
            {
                name: "卫星授时与守时精度",
                value: <><div>授时精度1μs 守时精度1ms</div><div>(卫星信号失锁后6小时内)</div></>,
            },
            {
                name: "工作模式",
                value: "自主采集+平板电脑现场无线质控",
            },
            {
                name: "LED状态指示",
                value: "可提示采集站状态、卫星时钟同步状态、无线数传状态",
            },
            {
                name: "数据回收方式",
                value: "无线数据回传、USB3.0线、回收站",
            },
        ],
        detectors: [
            {
                name: "检波器",
                value: <>5Hz/10Hz可选</>
            },
            {
                name: "灵敏度",
                value: <><div>78.7V/m/s@10Hz</div><div>76.7V/m/s@5Hz</div></>
            }
        ],
        physics: [
            {
                name: "重量",
                value: <>1.1kg</>
            },
            {
                name: "外部尺寸",
                value: <>直径12cm,高度16cm</>
            },
            {
                name: "工作温度范围",
                value: <>-40℃ ~ +70℃</>
            }
        ],
    },
    {
        title: "ALLSEIS-3CLF 一体化短周期地震计",
        src: img_3c,
        profile: (
            <ul>
                <li>全内置一体化短周期地震计，实现在固定测位上按照预先设定的采集参数，对内置正交三分量高灵敏度短周期地震检波器通道进行连续地数字化同步采集，并将采集记录存储在采集站内部的大容量非易失性存储器中；</li>
                <li>32位Δ-Σ模数转换器， 高精度数字化采集与记录，瞬时动态范围≥144dB；</li>
                <li>内置高灵敏度卫星定位与授时模块，配合内置+外置高灵敏度有源天线，支持埋置应用，最大程度上减小卫星授时失锁概率；</li>
                <li>卫星授时连续驯服策略配合高稳定度内部时钟源，实现微秒量级精度的广域系统同步采集； </li>
                <li>内置无线模块，支持采集现场设备自检、无线状态查询、采集数据的回读及实时回传；</li>
                <li>内部160WH可充电锂电池组，连续记录大于600小时；可选配外接大容量电池单元，工况下外电池为主，内电池为辅，由内置电 源管理单元自动切换，实现超长时间连续采集与记录；</li>
                <li>P&R（即布即采）工作模式实现野外施工效率最大化；</li>
                <li>防水耐腐蚀高强度工程塑料外壳。体积小（14D x 16H cm）、重量轻（2.4Kg），便于野外运输与施工。</li>
            </ul>
        ),
        bases: [
            {
                name: "检波器配置",
                value: <>内置正交三分量高灵敏度短周期地震检波器，频率 响应范围：0.2Hz（5s）~150Hz</>,
            },
            {
                name: "数字化方案",
                value: <>3x32位高精度Δ-Σ模数转换器，瞬时动态范围优于 144dB</>,
            },
            {
                name: "固态存储容量",
                value: <>32G，64G可选 </>,
            },
            {
                name: "供电",
                value: <>内部160WH可充电锂电池组，连续工作时长大于 600小时；可选配外部大容量电池单元</>,
            },
            {
                name: "卫星授时与守时精度",
                value: <><div>授时精度：+/- 1μs</div><div>守时精度：+/- 1ms (卫星信号失锁后 6 小时内)</div></>,
            },
            {
                name: "工作模式",
                value: "自主采集+工业级平板电脑现场无线质控",
            },
            {
                name: "LED状态指示",
                value: "采集站状态、卫星时钟同步状态、无线数传状态",
            },
            {
                name: "数据回收方式",
                value: "数据回收电缆+无线数据回传",
            },
            {
                name: "重量",
                value: <>2.4kg</>
            },
            {
                name: "外部尺寸",
                value: <>直径14cm,高度16cm</>
            },
            {
                name: "工作温度范围",
                value: <>-40℃ ~ +70℃</>
            }
        ],
        detectors: [
            {
                name: "ADC分辨率",
                value: <>32位</>
            },
            {
                name: "采样间隔",
                value: <>2ms、4ms、10ms、20ms可配置 </>
            },
            {
                name: "前置可编程放大",
                value: <>x1、x2、x4、x8、x16（0dB、 6dB、12dB、18dB、24dB</>
            },
            {
                name: "增益精度",
                value: <>0.1%</>
            },
            {
                name: "模拟信号输入",
                value: (
                    <>
                        <div className='gsde-row'>
                            <div className='gsde-col6'>
                                ±2.5Vp-p@x1 gain
                            </div>
                            <div className='gsde-col6'>
                                ±625mVp-p@x4 gain
                            </div>
                        </div>
                        <div className='gsde-row'>
                            <div className='gsde-col6'>
                                ±156mVp-p@x16 gain
                            </div>
                        </div>
                    </>
                )
            },
            {
                name: "实时动态范围@4ms",
                value: (
                    <>
                        <div className='gsde-row'>
                            <div className='gsde-col6'>
                                144dB @ x1 gain
                            </div>
                            <div className='gsde-col6'>
                                140dB @ x4 gain
                            </div>
                        </div>
                        <div className='gsde-row'>
                            <div className='gsde-col6'>
                                133dB @ x16 gain
                            </div>
                        </div>
                    </>
                )
            },
            {
                name: "等效输入噪音",
                value: (
                    <>
                        <div className='gsde-row'>
                            <div className='gsde-col6'>
                                0.1μV @ x1 gain
                            </div>
                            <div className='gsde-col6'>
                                0.04μV @ x4 gain
                            </div>
                        </div>
                        <div className='gsde-row'>
                            <div className='gsde-col6'>
                                0.025μV @ x16 gain
                            </div>
                        </div>
                    </>
                )
            },
            {
                name: "道间串扰",
                value: <>{"<110dB"}</>
            },
            {
                name: "共模抑制比",
                value: <>{">110dB"}</>
            }
        ],
        physics: [
            {
                name: "频带宽度",
                value: <>0.2Hz（5s）～150Hz </>
            },
            {
                name: "灵敏度",
                value: <>200V/m/s（±10％）</>
            },
            {
                name: "最大倾角",
                value: <>±5°</>
            },
            {
                name: "道间幅度一致性",
                value: <>{"<5% "}</>
            },
            {
                name: "道间相位一致性",
                value: <>{"<0.1s"}</>
            },
            {
                name: "横向振动抑制",
                value: <>{"<0.1%"}</>
            }
        ],
    },
    {
        title: "ALLSEIS-4C 一体化便携式地震采集节点",
        src: img_4c,
        profile: (
            <ul>
                <li>全内置一体化短周期地震计，实现在固定测位上按照预先设定的采集参数，对内置正交三分量高灵敏度短周期地震检波器通道进行连续地数字化同步采集，并将采集记录存储在采集站内部的大容量非易失性存储器中； </li>
                <li>24位Δ-Σ模数转换器， 高精度数字化采集与记录，瞬时动态范围 ≥123dB； </li>
                <li>内置高灵敏度卫星定位与授时模块，配合内置+外置高灵敏度有源天线，支持埋置应用，最大程度上减小卫星授时失锁概率；</li>
                <li>卫星授时连续驯服策略配合高稳定度内部时钟源，实现微秒量级精度的广域系统同步采集； </li>
                <li>内置无线模块，支持采集现场设备自检、无线状态查询、采集数据的回读及实时回传； </li>
                <li>内部160WH可充电锂电池组，连续记录大于600小时；可选配外接大容量电池单元，工况下外电池为主，内电池为辅，由内置电 源管理单元自动切换，实现超长时间连续采集与记录； </li>
                <li>P&R（即布即采）工作模式实现野外施工效率最大化； </li>
                <li>防水耐腐蚀高强度工程塑料外壳。体积小（14D x 16H cm）、重量轻（2.5Kg），便于野外运输与施工。</li>
            </ul>
        ),
        bases: [
            {
                name: "检波器配置",
                value: <>内置正交三分量高灵敏度短周期地震检波器，频率 响应范围：2.5Hz~180Hz+100Hz单通道</>,
            },
            {
                name: "数字化方案",
                value: <>3x24位高精度Δ-Σ模数转换器，瞬时动态范围优于123dB</>,
            },
            {
                name: "固态存储容量",
                value: <>32G，64G可选 </>,
            },
            {
                name: "供电",
                value: <>内部160WH可充电锂电池组，连续工作时长大于 600小时；可选配外部大容量电池单元</>,
            },
            {
                name: "卫星授时与守时精度",
                value: <><div>授时精度：+/- 1μs</div><div>守时精度：+/- 1ms (卫星信号失锁后 6 小时内)</div></>,
            },
            {
                name: "工作模式",
                value: "自主采集+工业级平板电脑现场无线质控",
            },
            {
                name: "LED状态指示",
                value: "采集站状态、卫星时钟同步状态、无线数传状态",
            },
            {
                name: "数据回收方式",
                value: "数据回收电缆+无线数据回传",
            },
            {
                name: "重量",
                value: <>2.5kg</>
            },
            {
                name: "外部尺寸",
                value: <>直径14cm,高度16cm</>
            },
            {
                name: "工作温度范围",
                value: <>-40℃ ~ +70℃</>
            }
        ],
        detectors: [
            {
                name: "ADC分辨率",
                value: <>24位</>
            },
            {
                name: "采样间隔",
                value: <> 0.5ms、1ms、2ms、4ms可配置</>
            },
            {
                name: "前置可编程放大",
                value: <>x1、x2、x4、x8、x16（0dB、 6dB、12dB、18dB、24dB）</>
            },
            {
                name: "增益精度",
                value: <>0.1%</>
            },
            {
                name: "模拟信号输入",
                value: (
                    <>
                        <div className='gsde-row'>
                            <div className='gsde-col6'>
                                ±2.5Vp-p@x1 gain
                            </div>
                            <div className='gsde-col6'>
                                ±625mVp-p@x4 gain
                            </div>
                        </div>
                        <div className='gsde-row'>
                            <div className='gsde-col6'>
                                ±156mVp-p@x16 gain
                            </div>
                        </div>
                    </>
                )
            },
            {
                name: "实时动态范围@4ms",
                value: (
                    <>
                        123dB @ x1 gain
                    </>
                )
            },
            {
                name: "等效输入噪音",
                value: (
                    <>
                        1μV @ x1 gain
                    </>
                )
            },
            {
                name: "道间串扰",
                value: <>{"＜100dB"}</>
            },
            {
                name: "共模抑制比",
                value: <>{">95dB"}</>
            }
        ],
        physics: [
            {
                name: "频带宽度",
                value: <>2.5Hz～180Hz；100Hz-800Hz</>
            },
            {
                name: "灵敏度",
                value: <>100V/m/s（±10％）</>
            },
            {
                name: "最大倾角",
                value: <>±5°</>
            },
            {
                name: "道间幅度一致性",
                value: <>{"<5% "}</>
            },
            {
                name: "道间相位一致性",
                value: <>{"<0.1s"}</>
            },
            {
                name: "横向振动抑制",
                value: <>{"<0.1%"}</>
            }
        ],
    }
]


export default function Products() {

    function getAllseisItems() {
        let items = [];
        for (let allse of allseisdata) {
            items.push(<AllseisItem data={allse} />)
        }
        return items;
    }

    return (
        <div className='gsde-container gsde-row product'>
            <AllseisShow>
                {getAllseisItems()}
            </AllseisShow>
        </div>
    )
}